import { Device } from "~/Device";
import * as Driver from "~/Driver";
import { Order } from "~/Order";

export type Type = ReturnType<
  | typeof status
  | typeof name
  | typeof asset
  | typeof device
  | typeof timerCycle
  | typeof timerShift
  | typeof timerDrive
  | typeof timerBreak
>;

export const status = () => "status" as const;
export const name = () => "name" as const;
export const asset = () => "asset" as const;
export const device = () => "device" as const;
export const timerCycle = () => "timerCycle" as const;
export const timerShift = () => "timerShift" as const;
export const timerDrive = () => "timerDrive" as const;
export const timerBreak = () => "timerBreak" as const;

export const toOrdering = (
  type: Type
): Order<Driver.Driver & { readonly latestPairing?: Driver.Pairing.Pairing }> =>
  Order.fromCompare((a, b) => {
    switch (type) {
      case status():
        return Order.optionally(Driver.Status.compare)(a.status, b.status);
      case name():
        return Order.reverse(
          Order.optionally(Driver.Name.compare)(a.name, b.name)
        );
      case asset():
        return Order.optionally(Driver.Pairing.compare)(
          a.latestPairing,
          b.latestPairing
        );
      case device():
        return Order.optionally(Device.compare)(
          a.device && { device: a.device },
          b.device && { device: b.device }
        );
      case timerCycle():
        return Order.optionally(Order.number().compare)(
          a.hoursOfService?.timers?.cycle.timer.duration,
          b.hoursOfService?.timers?.cycle.timer.duration
        );
      case timerShift():
        return Order.optionally(Order.number().compare)(
          a.hoursOfService?.timers?.shift.timer.duration,
          b.hoursOfService?.timers?.shift.timer.duration
        );
      case timerDrive():
        return Order.optionally(Order.number().compare)(
          a.hoursOfService?.timers?.drive.timer.duration,
          b.hoursOfService?.timers?.drive.timer.duration
        );
      case timerBreak():
        return Order.optionally(Order.number().compare)(
          a.hoursOfService?.timers?.break.timer.duration,
          b.hoursOfService?.timers?.break.timer.duration
        );
    }
  });
